'helper'.trashAll('POReceipt')
'helper'.trashAll('PO')
'helper'.trashAll('Inventory')
'helper'.clearWCStockLevels()
'Inventory'.click()
'mainTable'.forEach('quantityOnHand !== 0')
  'Adjust Qty'.click() 
  'Product'.shouldntEqual('')
  'Quantity Change'.enterExpression('- quantityOnHand')
  'Save'.click()
  'Inventory'.click()
  'mainTable'.endForEach()
'stocktend_settings'.click()
'Short Date Format'.enter('dd/mm/yyyy')
'OK'.click()
'stocktend_purchaseOrders'.click()
'helper'.trashAll('Transaction')
'Add'.click()
'Purchase Order Number'.enter('PO00001')
'Order Date'.enter('28/4/2019')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Unit Price (Inc Tax)'.enter('5.00')
'Quantity'.enter('4')
'OK'.click()
'OK'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00002')
'Order Date'.enter('28/5/2019')
'Add Line'.click()
'Product'.chooseOption('Shórts - Blue (SB01)')
'Unit Price (Inc Tax)'.enter('4.78')
'Quantity'.enter('8')
'OK'.click()
'Receive Purchases'.click()
'mainTable./PO00001/.Enter Receipt'.click()
'Received Date'.enter('28/4/2019')
'OK'.click()
'mainTable./PO00002/.Enter Receipt'.click()
'Received Date'.enter('28/5/2019')
'OK'.click()
'helper'.clearWCOrders()
'View Profits'.click()
'mainTable'.shouldBeEmpty()
'From Date'.enter('1/7/2019')
'To Date'.enter('30/6/2099')
'Go'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Sales Value'.shouldEqual('0.00')
'helper'.addWCOrder({product: 'Shórts - Blue (SB01)', quantity: 1, unitPrice: 10.00, orderDate: '28/6/2019'})
'helper'.flushCache()
'Sales and Invoices'.click()
'mainTable.0.Product'.shouldEqual('Shórts - Blue (SB01)')
'mainTable.0.Amount Ex Tax'.shouldEqual('9.09')
'mainTable.0.Quantity'.shouldEqual('1')
'mainTable.0.View Order'.click()
'View Sales Order'.shouldBeCurrentPage()
'Order Number'.shouldntEqual('')
'Order Date'.shouldEqual('Jun 28 2019')
'itemsTotalExTax'.shouldEqual('9.09')
'Tax'.shouldEqual('0.91')
'Shipping'.shouldEqual('0.00')
'Total'.shouldContain('10.00')
'Lines'.shouldHaveCount(1)
'Lines.0.Product'.shouldEqual('Shórts - Blue (SB01)')
'Lines.0.Unit Price'.shouldEqual('9.09')
'Lines.0.Quantity'.shouldEqual('1')
'Lines.0.Amount'.shouldEqual('9.09')
'Lines.0.Tax'.shouldEqual('0.91')
'Lines.0.Amount Inc Tax'.shouldEqual('10.00')
'Download Invoice PDF'.click()
'browser'.back()
'helper'.clearWCOrders()
'helper'.flushCache()
'View Profits'.click()
'From Date'.enter('1/7/2019')
'To Date'.enter('30/6/2020')
'Go'.click()
'searcher'.enter('s')
'mainTable./Shórts - Blue (SB01)/.Sales Value'.shouldEqual('0.00')
'browser'.back()
'helper'.addWCOrder({product: 'Shórts - Blue (SB01)', quantity: 2, unitPrice: 9.50, orderDate: '1/7/2019'})
'View Profits'.click()
'From Date'.shouldEqual('01/07/2019')
'To Date'.shouldEqual('30/06/2020')
'searcher'.enter('Blue')
'Go'.click()
'mainTable./Shórts - Blue (SB01)/.Sales Value'.shouldEqual('19.00')
'mainTable./Shórts - Blue (SB01)/.Cost of Goods Sold'.shouldEqual('9.71')
'mainTable./Shórts - Blue (SB01)/.Gross Profit Value'.shouldEqual('9.29')
'mainTable./Shórts - Blue (SB01)/.Gross Profit %'.shouldEqual('48.91')
'helper'.addWCOrder({product: 'Shórts - Blue (SB01)', quantity: 3, unitPrice: 9.25, orderDate: '1/8/2019'})
'Go'.click()
'mainTable./Shórts - Blue (SB01)/.Sales Value'.shouldEqual('46.75')
'mainTable./Shórts - Blue (SB01)/.Cost of Goods Sold'.shouldEqual('24.27')
'mainTable./Shórts - Blue (SB01)/.Gross Profit Value'.shouldEqual('22.48')
'mainTable./Shórts - Blue (SB01)/.Gross Profit %'.shouldEqual('48.09')
'helper'.addWCOrder({product: 'Shórts - Blue (SB01)', quantity: 1, unitPrice: 9.00, orderDate: '1/7/2020'}) // NOTE: not in the selected date range
'Go'.click()
'mainTable./Shórts - Blue (SB01)/.Sales Value'.shouldEqual('46.75')
'mainTable./Shórts - Blue (SB01)/.Cost of Goods Sold'.shouldEqual('24.27')
'mainTable./Shórts - Blue (SB01)/.Gross Profit Value'.shouldEqual('22.48')
'mainTable./Shórts - Blue (SB01)/.Gross Profit %'.shouldEqual('48.09')
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 1, unitPrice: 20.00, orderDate: '1/7/2019'})
'View Profits'.click()
'Go'.click()
'searcher'.enter('')
'mainTable./Polo (P01)/.Sales Value'.shouldEqual('20.00')
'mainTable./Polo (P01)/.Cost of Goods Sold'.shouldEqual('Unknown')
'mainTable./Polo (P01)/.Gross Profit Value'.shouldEqual('Unknown')
'mainTable./Polo (P01)/.Gross Profit %'.shouldEqual('Unknown')
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00003')
'Order Date'.enter('2/7/2019')
'Add Line'.click()
'Product'.chooseOption('Polo (P01)')
'Unit Price (Inc Tax)'.enter('23.00')
'Quantity'.enter('1')
'OK'.click()
'OK'.click()
'Receive Purchases'.click()
'mainTable./PO00003/.Enter Receipt'.click()
'Received Date'.enter('2/7/2019')
'OK'.click()
'View Profits'.click()
'Go'.click()
'mainTable./Polo (P01)/.Sales Value'.shouldEqual('20.00')
'mainTable./Polo (P01)/.Cost of Goods Sold'.shouldEqual('23.00')
'mainTable./Polo (P01)/.Gross Profit Value'.shouldEqual('-3.00')
'mainTable./Polo (P01)/.Gross Profit %'.shouldEqual('-15.00')
'stocktend_purchaseOrders'.click()
'Add'.click()
'Purchase Order Number'.enter('PO00004')
'Order Date'.enter('20/8/2019')
'Add Line'.click()
'Product'.chooseOption('Polo (P01)')
'Unit Price (Inc Tax)'.enter('11.00')
'Quantity'.enter('6')
'OK'.click()
'OK'.click()
'Receive Purchases'.click()
'mainTable./PO00004/.Enter Receipt'.click()
'Received Date'.enter('20/8/2019')
'OK'.click()
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 2, unitPrice: 17.65, orderDate: '20/9/2019'})
'View Profits'.click()
'Go'.click()
'mainTable./Polo (P01)/.Sales Value'.shouldEqual('55.30')
'mainTable./Polo (P01)/.Cost of Goods Sold'.shouldEqual('45.00')
'mainTable./Polo (P01)/.Gross Profit Value'.shouldEqual('10.30')
'mainTable./Polo (P01)/.Gross Profit %'.shouldEqual('18.63')
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 3, unitPrice: 19.23, orderDate: '2/3/2020'})
'View Profits'.click()
'Go'.click()
'mainTable./Polo (P01)/.Sales Value'.shouldEqual('112.99')
'mainTable./Polo (P01)/.Cost of Goods Sold'.shouldEqual('78.00')
'mainTable./Polo (P01)/.Gross Profit Value'.shouldEqual('34.99')
'mainTable./Polo (P01)/.Gross Profit %'.shouldEqual('30.97')
'helper'.addWCOrder({product: 'Polo (P01)', quantity: 1, unitPrice: 9.00, orderDate: '1/7/2020'})
'View Profits'.click()
'Go'.click()
'mainTable./Polo (P01)/.Sales Value'.shouldEqual('112.99')
'mainTable./Polo (P01)/.Cost of Goods Sold'.shouldEqual('78.00')
'mainTable./Polo (P01)/.Gross Profit Value'.shouldEqual('34.99')
'mainTable./Polo (P01)/.Gross Profit %'.shouldEqual('30.97')
'helper'.setWCStockLevel('Hoodie with Pocket (HP01)', 10)
'helper'.flushCache()
'Inventory'.click()
'mainTable./Hoodie with Pocket (HP01)/.Quantity On Hand'.shouldEqual('10')
'mainTable./Hoodie with Pocket (HP01)/.Product'.click()
'Adjust Value'.click()
'Avg Unit Cost'.enter('33.00')
'OK'.click()
'OK'.click()
'mainTable./Hoodie with Pocket (HP01)/.Avg Unit Cost'.shouldEqual('33.00')
'mainTable./Hoodie with Pocket (HP01)/.Inventory Value'.shouldEqual('330.00')
'helper'.addWCOrder({product: 'Hoodie with Pocket (HP01)', quantity: 1, unitPrice: 50.00, orderDate: '28/6/2020', status: "wc-pending"})
'View Profits'.click()
'From Date'.enter('1/7/2019')
'To Date'.enter('30/6/2020')
'Go'.click()
'mainTable./Hoodie with Pocket (HP01)/.Sales Value'.shouldEqual('49.99')
'mainTable./Hoodie with Pocket (HP01)/.Cost of Goods Sold'.shouldEqual('33.00')
'mainTable./Hoodie with Pocket (HP01)/.Gross Profit Value'.shouldEqual('16.99')
'Inventory'.click()
'mainTable./Hoodie with Pocket (HP01)/.Quantity On Hand'.shouldEqual('10')
'mainTable./Hoodie with Pocket (HP01)/.Inventory Value'.shouldEqual('330.00')
'browser'.back()
'helper'.flushCache()
'Inventory'.click()
'mainTable./Hoodie with Pocket (HP01)/.Inventory Value'.shouldEqual('330.00')
'Receive Purchases'.click()
'mainTable'.shouldBeEmpty()
'View All Receipts'.click()
'mainTable./PO00004-01/.Trash'.click()
'mainTable./PO00004-01/.Really Trash?'.click()
'Back'.click()
'Receive Purchases'.shouldBeCurrentPage()
'mainTable'.shouldHaveCount(2) // Including total
'Sales and Invoices'.click()
'mainTable.<columnHeadings>.Order Number'.click()
'mainTable.0.Product'.shouldEqual('Shórts - Blue (SB01)')
'mainTable.<columnHeadings>.Order Number'.click()
'mainTable.0.Product'.shouldEqual('Hoodie with Pocket (HP01)')
